interface Props {
  saveDraft: () => void,
  publish: () => void
}

export const getNewProductUpdateActions = ({ saveDraft, publish }: Props) => (
  [
    {
      isPrincipal: true,
      title: 'Save as draft',
      onClick: saveDraft,
      class: 'qa-save-draft'
    },
    {
      title: 'Publish Now',
      onClick: publish,
      class: 'qa-publish'
    }
  ]
)